export default "__VITE_ASSET__C1dPQ5Or__"